import React, { useState, useEffect } from 'react';

function TOSPage() {
  const [tosText, setTosText] = useState('');

  useEffect(() => {
    const fetchedTOS = `
      <h2><strong>1. Introduction</strong></h2>
      <p>These Terms of Service ("Terms") govern your access to and use of the BogBot Discord bot (the "Bot"), provided by OldMoldyCake ("we," "us," or "our"). By using the Bot, you agree to be bound by these Terms. If you disagree with any part of the Terms, then you may not access the Bot. This Bot is intended for users who are at least 13 years of age, in compliance with Discord's Terms of Service.</p>

      <h2><strong>2. Bot Functionality</strong></h2>
      <p>The Bot provides entertainment services, including a chatbot functionality and music playback. The Bot utilizes AI and interacts with various third-party APIs (listed in Section 7).</p>

      <h2><strong>3. Data Collection and Privacy</strong></h2>
      <ul>
        <li><strong>Data Collected:</strong> The Bot collects the following data:
          <ul>
            <li>Chat messages in channels the Bot has access to (excluding dedicated bot command channels).</li>
            <li>User IDs.</li>
            <li>Usernames.</li>
            <li>Server (Guild) IDs.</li>
            <li>This data is stored in a ChromaDB vector database for long-term memory and improved user interactions.</li>
          </ul>
        </li>
        <li><strong>Data Usage:</strong> The collected data is used for:
          <ul>
            <li>Bot functionality (responding to commands, playing music, providing AI chat responses).</li>
            <li>Analytics to understand Bot usage.</li>
            <li>Improving the Bot's performance and features.</li>
          </ul>
        </li>
        <li><strong>Data Sharing:</strong>
          <ul>
            <li>Chat data and prompts are sent to Google via API for AI interactions (Gemini, Imagen3).</li>
            <li>No other user data is shared with third parties. Embeddings and music playback (Lavalink) are handled on our own servers.</li>
          </ul>
        </li>
        <li><strong>Data Retention:</strong> Your data is retained indefinitely or until you request deletion. If you request deletion and subsequently interact with the Bot again, your data will be collected again as it's necessary for core functionality.</li>
        <li><strong>Sensitive Information:</strong> The bot will store chats from channels that it has access to. This may include sensitive information if present in those chats.</li>
        <li><strong>Cryptocurrency:</strong> The bot uses the CoinMarketCap API to display cryptocurrency prices. This does <em>not</em> involve any storage of user financial data or transactions.</li>
      </ul>

      <h2><strong>4. User Conduct</strong></h2>
      <ul>
        <li><strong>Prohibited Content:</strong> You agree not to submit any explicit images to the Bot. You also agree not to use slurs or engage in racist behavior in text fields that are processed by the bot.</li>
        <li><strong>Prohibited Actions:</strong> You are prohibited from:
          <ul>
            <li>Spamming the Bot.</li>
            <li>Attempting SQL injection attacks.</li>
            <li>Attempting to exploit any vulnerabilities in the Bot.</li>
          </ul>
        </li>
        <li><strong>Enforcement:</strong> Violation of these conduct rules will result in a ban from using the Bot.</li>
      </ul>

      <h2><strong>5. Third-Party APIs</strong></h2>
      <p>The Bot utilizes the following third-party APIs:</p>
      <ul>
        <li>Google Gemini (AI chat)</li>
        <li>Google Imagen3 (Image generation)</li>
        <li>CoinMarketCap (Cryptocurrency price data)</li>
        <li>Discord API</li>
        <li>Spotify API</li>
        <li>YouTube API</li>
      </ul>
      <p>Your use of the Bot is also subject to the terms of service of these third-party providers. We are not responsible for the functionality or availability of these services.</p>

      <h2><strong>6. No Warranties and Disclaimer</strong></h2>
      <p>The Bot is provided "as is" and "as available" without any warranties of any kind, express or implied. We do not guarantee the Bot's availability, functionality, accuracy, or reliability. The bot is self-hosted and may be unavailable due to factors such as power outages. The bot does not provide professional advice of any kind (financial, legal, medical, etc.)</p>

      <h2><strong>7. Limitation of Liability</strong></h2>
      <p>To the maximum extent permitted by applicable law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the bot; (ii) any conduct or content of any third party on the bot, including without limitation, any defamatory, offensive or illegal conduct of other users or third parties; (iii) any content obtained from the bot; or (iv) unauthorized access, use or alteration of your transmissions or content.</p>

      <h2><strong>8. Indemnification</strong></h2>
      <p>You agree to indemnify and hold harmless OldMoldyCake and its officers, directors, employees, and agents from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from or relating to your use of the Bot or your violation of these Terms.</p>

      <h2><strong>9. Governing Law</strong></h2>
      <p>These Terms shall be governed by and construed in accordance with the laws of the State of Arkansas, United States, without regard to its conflict of law principles.</p>

      <h2><strong>10. Changes to Terms</strong></h2>
      <p>We reserve the right to modify or replace these Terms at any time. We will provide notice of any changes by posting the new Terms on the Discord server where the Bot is used. Your continued use of the Bot after any such changes constitutes your acceptance of the new Terms.</p>

      <h2><strong>11. Contact Information</strong></h2>
      <p>If you have any questions about these Terms, please contact us via the <code>/feedback</code> command within the Bot (or a dedicated command to be implemented later).</p>

      <h2><strong>12. Termination</strong></h2>
      <p>We may terminate or suspend access to our Bot immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
    `;
    setTosText(fetchedTOS);
  }, []);

  return (
    <div style={{ minHeight: '100vh', marginLeft: "5%", marginRight:"5%", marginTop:'3%',  }}>
      <main>
      <h1 style={{color:'white'}}><strong>TERMS OF SERVICE FOR BOGBOT</strong></h1>
      <p style={{paddingBottom: '5%', color:'white'}}><strong>Effective Date:</strong> 2/08/2025</p>
      <div
        style={{
          overflowY: 'auto',
          padding: '10px',
          color: 'white', 
        }}
        
        dangerouslySetInnerHTML={{ __html: tosText }}
      />

      </main>
    </div>
  );
}

export default TOSPage;